import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { CART_SUBTOTAL_STARTER_TEMPLATE, CART_SUBTOTAL_VARIABLES, CartSubtotalFormShape } from './cart-subtotal.model';

@Component({
  selector: 'smart-cart-form-cart-subtotal-editor',
  templateUrl: './cart-subtotal.component.html',
  styleUrls: ['./cart-subtotal.component.scss'],
  standalone: false,
})
export class SmartCartFormCartSubtotalEditorComponent {
  @Input({ required: true }) formGroup!: FormGroup<CartSubtotalFormShape>;
  @Input() usageToken = '';

  readonly starterTemplate = CART_SUBTOTAL_STARTER_TEMPLATE;
  readonly customCodeVariables = CART_SUBTOTAL_VARIABLES;
}
